import Login from 'pages/signin';

import { useAuth } from 'hooks';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { isAuthorizeSuppressed, startAuthorizeRedirect } from 'utils/ssoClient';

export const withAuth = (Component) => {
  const Auth = (props) => {
    const { isLoggedIn, isInitialised, status, participant, setSession } = useAuth();
    const router = useRouter();
    const attemptedSsoRef = useRef(false);

    useEffect(() => {
      if (isLoggedIn && !participant.approvedPolicy && !participant.approvedTermsAndConditions) {
        router.push('/pages/privacy-policy');
      }
    }, [isLoggedIn, participant.approvedPolicy, participant.approvedTermsAndConditions, status]);

    // Mientras hydrateSession() no termine, no sabemos si el usuario está
    // logueado. Renderizar <Login /> acá causa el "flash" de la pantalla de
    // login antes de que el AuthContext confirme la sesión (o rote el token si
    // estaba expirado). Devolver null hasta que isInitialised sea true evita
    // ese parpadeo. Reemplazá por un spinner si querés indicar carga.
    if (!isInitialised) {
      return null;
    }

    if (!isLoggedIn) {
      // Entrada transparente: antes de mostrar el form, intentamos SSO una vez.
      // Si hay cookie de sesión (venís de otra app del mismo programa), el
      // /authorize emite un code y entrás sin credenciales. Si no hay sesión,
      // el callback cae en /signin (que NO usa withAuth), así que no hay loop.
      if (!attemptedSsoRef.current && !isAuthorizeSuppressed() && typeof window !== 'undefined') {
        attemptedSsoRef.current = true;
        const programId = Number(process.env.NEXT_PUBLIC_PROGRAM_ID);
        if (Number.isFinite(programId) && programId > 0) {
          void startAuthorizeRedirect({ programId, returnTo: router.asPath });
          return null; // redirigiendo a /authorize
        }
      }
      return <Login />;
    }

    return <Component {...props} />;
  };

  // Copy getInitial props so it will run as well
  if (Component.getInitialProps) {
    Auth.getInitialProps = Component.getInitialProps;
  }

  return Auth;
};
